import { FunctionComponent, useState } from 'react';

import { MainContainer } from '../../../layout/components/MainContainer';
import { TableDeviceHistory } from './components/TableDeviceHistory';

export const HistoryDevice: FunctionComponent = () => {
  const [openRightMenu, setOpenRightMenu] = useState(false);

  const renderContent = () => {
    return (
      <div className="flex w-full h-full relative flex-row">
        <div className="flex grow h-full relative flex-col content-center items-center justify-center overflow-x-auto  p-4 ">
          <TableDeviceHistory />
        </div>
      </div>
    );
  };

  const loading = false;

  return (
    <MainContainer
      openRightMenu={openRightMenu}
      setOpenRightMenu={setOpenRightMenu}
      loading={loading}
      rightMenuContent={<></>}>
      {renderContent()}
    </MainContainer>
  );
};
